<template>
  <div>
    <router-link class="tdclickable" :to="{ name: 'WarehousesDocumentItem', params: { id: object.id } }">
      {{ object.simple_title }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "WarehouseDatatableTDDocumentTitle",
  props: {
    object: {
      type: Object
    }
  },
}
</script>
